import { useLocation } from "react-router-dom";
import { HUBSPOT_CONSULT_FORM_ID } from "../api/hubspot";
import AiLpFormPage from "./AiLpFormPage";

// 無料相談（個別オンライン相談・お問い合わせ）ページ。
// 無料AI診断からの遷移時は、診断で入力済みの情報＋診断結果を引き継いで初期表示する。
function AiAdoptionConsult() {
  const { state } = useLocation();
  const fd = state?.fromDiagnosis;
  const initialValues = fd
    ? {
        company: fd.company || "",
        name: fd.name || "",
        email: fd.email || "",
        message: fd.message || "",
      }
    : undefined;

  return (
    <AiLpFormPage
      formId={HUBSPOT_CONSULT_FORM_ID || undefined}
      leadKind="consult"
      eyebrow="無料相談"
      title="まずは、現状の課題をお聞かせください"
      lead={
        fd
          ? "診断結果と入力内容を引き継ぎました。このまま送信いただけます。"
          : "「組織でAIを使いこなしたい」「ChatGPTを入れたが効果が出ない」——そんな段階でも歓迎です。"
      }
      fields={[
        { name: "company", label: "会社名", type: "text", required: true },
        { name: "name", label: "お名前", type: "text", required: true },
        {
          name: "email",
          label: "メールアドレス",
          type: "email",
          required: true,
        },
        { name: "tel", label: "電話番号", type: "tel", required: false },
        {
          name: "message",
          label: "ご相談内容",
          type: "textarea",
          required: false,
        },
      ]}
      initialValues={initialValues}
      alreadySubmitted={!!fd}
      submitLabel="送信する"
      doneTitle="お問い合わせありがとうございます"
      doneMsg="担当より2〜3営業日以内にご連絡します。現状の課題をお伺いするだけでも歓迎です。"
    />
  );
}

export default AiAdoptionConsult;
